import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconTriangleTop = props => (
  <SvgIcon {...props} viewBox="0 0 10 5">
    <path d="m0 4.9961 5.0016-4.9961 5.0074 5.0007z" />
  </SvgIcon>
);

export default IconTriangleTop;



// WEBPACK FOOTER //
// ./src/components/icons/IconTriangleTop.js